import React from 'react';
import { CircularProgress, Box, Backdrop, Typography } from '@mui/material';

const FullScreenLoading = ({ open = true }) => {
  return (
    <Backdrop
      open={open}
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1,
        backdropFilter: 'blur(3px)', // opcional: para efeito de desfoque
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // escurece a tela com opacidade
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <CircularProgress color="inherit" />
        <Typography variant="subtitle1" style={{ marginTop: '16px' }}>
        {'Carregando informações...'}
      </Typography>
      </Box>
    </Backdrop>
  );
};

export default FullScreenLoading;
